// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function areaTypeV5_decode($$enum) {
  if ($$enum === "TOWNSHIP" || $$enum === "STATE" || $$enum === "SCHOOL_DISTRICT" || $$enum === "SCHOOL" || $$enum === "NEIGHBORHOOD" || $$enum === "COUNTY" || $$enum === "CITY" || $$enum === "CENSUS_PLACE" || $$enum === "BLOCK_GROUP" || $$enum === "ZIP_CODE") {
    return $$enum;
  }
  
}

function areaTypeV5_fromString(str) {
  return areaTypeV5_decode(str);
}

var Utils = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: areaTypeV5_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NotificationSettings_areas",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "type_",
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Area",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
